






























































































import Vue from 'vue'
import moment from 'moment'
import { Popover } from 'element-ui'
import { KeyDict } from '@/types'
import { TranscodingRegion } from '@/types/admin'
import { SelfTestStats } from '@/types/users'

export default Vue.extend({
  name: 'SelfTestSummary',
  props: {
    selftestResults: {
      type: Object as () => SelfTestStats,
      required: true
    },
    labelQa: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    answerStyle (answer: string): Partial<CSSStyleDeclaration> {
      if (answer === 'Yes') {
        return { color: '#70BC24' }
      } else {
        return { color: '#F24637' }
      }
    },
    networkStyles (value: number|undefined, good: number, borderline: number): Partial<CSSStyleDeclaration> {
      if (value === undefined) {
        return { color: '#F24637' }
      }
      if (value >= good) {
        return { color: '#70BC24' }
      } else if (value >= borderline) {
        return { color: '#FF8C00' }
      } else {
        return { color: '#F24637' }
      }
    },
    networkStylesNeg (value: number|undefined, fail: number, borderline: number): Partial<CSSStyleDeclaration> {
      if (value === undefined) {
        return { color: '#F24637' }
      }
      if (value >= fail) {
        return { color: '#F24637' }
      } else if (value >= borderline) {
        return { color: '#FF8C00' }
      } else {
        return { color: '#70BC24' }
      }
    }
  },
  computed: {
    transcodingregions (): KeyDict<TranscodingRegion> {
      return this.$store.direct.state.admin.transcodingregions
    },
    seevideolabel (): string {
      return this.labelQa !== '' ? 'answer-seeownvideo' : ''
    },
    hearaudiolabel (): string {
      return this.labelQa !== '' ? 'answer-hearownaudio' : ''
    },
    seepreviewlabel (): string {
      return this.labelQa !== '' ? 'answer-seepreviewvideo' : ''
    },
    hearpreviewlabel (): string {
      return this.labelQa !== '' ? 'answer-hearpreviewaudio' : ''
    },
    uploadspeedlabel (): string {
      return this.labelQa !== '' ? 'answer-uploadspeed' : ''
    },
    uploadjitterlabel (): string {
      return this.labelQa !== '' ? 'answer-uploadjitter' : ''
    },
    uploadlatencylabel (): string {
      return this.labelQa !== '' ? 'answer-uploadlatency' : ''
    },
    downloadspeedlabel (): string {
      return this.labelQa !== '' ? 'answer-downloadspeed' : ''
    },
    downloadjitterlabel (): string {
      return this.labelQa !== '' ? 'answer-downloadjitter' : ''
    },
    downloadlatencylabel (): string {
      return this.labelQa !== '' ? 'answer-downloadlatency' : ''
    },
    scoreStyle (): Partial<CSSStyleDeclaration> {
      return this.networkStyles(this.selftestResults.network.upload?.score, 4, 2)
    },
    uploadStyle (): Partial<CSSStyleDeclaration> {
      return this.networkStyles(this.selftestResults.network.upload?.bandwidth, 3, 1)
    },
    downloadStyle (): Partial<CSSStyleDeclaration> {
      return this.networkStyles(this.selftestResults.network.download?.bandwidth, 5, 4)
    },
    uploadLatencyStyle (): Partial<CSSStyleDeclaration> {
      return this.networkStylesNeg(this.selftestResults.network.upload?.latency, 200, 100)
    },
    downloadLatencyStyle (): Partial<CSSStyleDeclaration> {
      return this.networkStylesNeg(this.selftestResults.network.download?.latency, 200, 100)
    },
    uploadJitterStyle (): Partial<CSSStyleDeclaration> {
      return this.networkStylesNeg(this.selftestResults.network.upload?.jitter, 100, 50)
    },
    downloadJitterStyle (): Partial<CSSStyleDeclaration> {
      return this.networkStylesNeg(this.selftestResults.network.download?.jitter, 100, 50)
    },
    errorMessage (): string {
      let error = ''
      if (!this.selftestResults.camerapermission) {
        error += 'Camera permission not given.<br>'
      }
      if (!this.selftestResults.seevideo) {
        error += 'Could not see camera.<br>'
      }
      if (!this.selftestResults.seepreview) {
        error += 'Could not see preview.<br>'
      }
      if (!this.selftestResults.microphonepermission) {
        error += 'Microphone permission not given.<br>'
      }
      if (!this.selftestResults.hearaudio) {
        error += 'Could not hear audio.<br>'
      }
      if (!this.selftestResults.hearpreview) {
        error += 'Could not hear audio of the preview.<br>'
      }
      const score = this.selftestResults.network.upload?.score || 0
      if (score < 4) {
        error += 'Network score too low.<br>'
      }
      return error
    },
    uploadSpeed (): string {
      const upload = this.selftestResults.network.upload?.bandwidth
      if (upload === undefined || isNaN(upload)) return 'Unknown'
      if (upload < 0.1) return 'Too low'
      if (upload < 15) {
        return (Math.round(upload * 10) / 10) + 'Mbps'
      }
      return '> 15Mbps'
    },
    downloadSpeed (): string {
      const download = this.selftestResults.network.download?.bandwidth
      if (download === undefined || isNaN(download)) return 'Unknown'
      if (download < 0.1) return 'Too low'
      if (download < 15) {
        return (Math.round(download * 10) / 10) + 'Mbps'
      }
      return '> 15Mbps'
    },
    summary (): string {
      if (this.errorMessage === '') {
        return 'Success'
      } else {
        const score = this.selftestResults.network.upload?.score || 0
        if (this.errorMessage === 'Network score too low.\n') {
          return score >= 2 ? 'Borderline' : 'Failed'
        } else {
          return 'Failed'
        }
      }
    },
    styles (): Partial<CSSStyleDeclaration> {
      if (this.summary === 'Success') {
        return { color: '#70BC24' }
      } else if (this.summary === 'Failed') {
        return { color: '#F24637' }
      } else {
        return { color: '#FF8C00' }
      }
    },
    lastRan (): string {
      return moment.unix(this.selftestResults.timestamp).format('M/D/YYYY h:mm a')
    },
    camerapermission (): string {
      return this.selftestResults.camerapermission ? 'Yes' : 'No'
    },
    microphonepermission (): string {
      return this.selftestResults.microphonepermission ? 'Yes' : 'No'
    },
    hearaudio (): string {
      return this.selftestResults.hearaudio ? 'Yes' : 'No'
    },
    seevideo (): string {
      return this.selftestResults.seevideo ? 'Yes' : 'No'
    },
    hearpreview (): string {
      return this.selftestResults.hearpreview ? 'Yes' : 'No'
    },
    seepreview (): string {
      return this.selftestResults.seepreview ? 'Yes' : 'No'
    },
    region (): string {
      const regions = Object.values(this.transcodingregions).filter(property => {
        // FIXME needs testing
        return Object.values(property.wrtcserver).some(server => server.url === this.selftestResults.region)
      })
      let regionName = 'None'
      if (regions.length > 0) {
        regionName = regions[0].name
      }
      return regionName
    }
  },
  components: {
    'el-popover': Popover
  }
})
